export default "__VITE_ASSET__DLYJfVE1__"